<template>
  <div>
    <!-- TODO: set 'is_disabled' based on filter -->
    <TransitionAccordion>
      <div v-if="!is_collapsed">
        <TTooltip
          v-for="(item, index) in items"
          :key="`expanded:${item.step_type}${index}`"
          :value="getToolTip(item)"
        >
          <ClickableListItem

            :id="item.id"
            :is_selected="item.step_type === step_type"
            :is_disabled="item.is_disabled"
            :has_lines="has_lines"
            :is_first="index == 0"
            :background_color="background_color"
            :foreground_color="foreground_color"
            @emittedClick="$emit('stepsClick', item.step_type)"
          >
            <!-- CLICKABLE LIST SLOTS -->
            <template #front>
              <TIcon
                :name="getStepIcon(item.step_type)"
              />
            </template>

            <template #descriptor>
              <TText
                :value="`${item.step_type.toUpperCase()}.steps`"
                :color="foreground_color"
                :size="11"
                :font_weight="300"
              />
            </template>

            <template #info>
              <TText
                :text="`${item.progress.done_count}/${item.progress.task_count}`"
                :color="foreground_color"
                :size="11"
                :font_weight="300"
              />
            </template>
          </ClickableListItem>
        </TTooltip>
      </div>
    </TransitionAccordion>

    <!-- TODO: set 'is_disabled' based on filter -->
    <TransitionAccordion>
      <div v-if="is_collapsed">
        <div class="work-package-circular-step-list">
          <TTooltip
            v-for="(item, index) in items"
            :key="`collapsed:${item.step_type}${index}`"
            :value="getToolTip(item)"
            class="work-package-circular-step-container"
            :style="`width: calc((100% - ${(items_per_row-1) * 8}px) / ${items_per_row});`"
          >
            <CircularProgressButton
              :icon="getStepIcon(item.step_type)"
              :value="getCollapsedProgressValue(item.progress.done_count, item.progress.task_count)"
              :has_no_tasks="item.progress.task_count === 0"
              :is_disabled="item.is_disabled"
              :width="4"
              items_per_row="1"
              :background_color="background_color"
              :foreground_color="foreground_color"
              @emittedClick="$emit('stepsClick', item.step_type)"
            />
          </TTooltip>
          <!-- :size="dynamic_width.width"
          :width="6" -->
        </div>
      </div>
    </TransitionAccordion>
  </div>
</template>

<script>
import ClickableListItem from '@/components/WorkPackageWIP/ClickableListItem.component.vue';
import CircularProgressButton from '@/components/WorkPackageWIP/CircularProgressButton.component.vue';
import { WorkPackageWIPMixin } from '@/mixins/WorkPackageWIPMixin.mixin.js';
import TransitionAccordion from '@/components/WorkPackageWIP/TransitionAccordion.component.vue';
import TText from '@/components/Taktify/TText.component.vue';
import TIcon from '@/components/Taktify/TIcon.component.vue';
import TTooltip from '@/components/Taktify/TTooltip.component.vue';

  export default {
    components: {
      ClickableListItem,
      CircularProgressButton,
      TransitionAccordion,
      TText,
      TIcon,
      TTooltip,
    },

    mixins: [
      WorkPackageWIPMixin,
    ],

    props: [
      'items', // is array of objects, contains icon, step_type and progress (object of numbers)
      'has_lines', // is boolean, deactivates first line draw
      'is_collapsed', // is boolean, toggles expanded/collapsed state
      'background_color', // is string, contains hexadecimal value of background
      'foreground_color', // is string, contains hexadecimal value of text, outlines etc.
      'items_per_row',
    ],

    data: () => ({
      selected_id: -1,
    }),
    computed: {
      step_type() {
        if (this.$route.matched[4] && this.$route.matched[4].name.includes('Steps')) {
          if (this.$route.matched[4].name.includes('TaktPlan')) {
            return this.$route.matched[4].name.substring(19, this.$route.matched[4].name.length-5);
          } else {
            // ProjectWallet
            return this.$route.matched[4].name.substring(23, this.$route.matched[4].name.length-5);
          }
        } else {
          return false;
        }
      }
    },
    methods: {
      // handleClick(item) {
      //   console.log(`${item.step_type} got selected!`);
      //   this.selected_id = item.id;
      //   this.$emit('stepsClick', item.step_type);
      // },

      // resetSelectedId() {
      //   this.selected_id = -1;
      // },

      getCollapsedProgressValue(done_count, task_count) {
        if(task_count <= 0) { // if there are no tasks at all
          return 0; // this is necessary cause either we divide by 0 or task_count was faulty to begin with
        }

        let done = parseInt(done_count);
        let tasks = parseInt(task_count);
        let progress = parseInt((done / tasks) * 100);

        return progress;
      },

      log(string, is_selected) {
        console.log(`${string} got ${is_selected ? 'selected' : 'deselected'}!`);
      },

      getToolTip(item){
        if (item.is_disabled) {
          return `${item.step_type} Steps are part of the TAKT.ing PRO.account.`;
        }
        return `${item.step_type} Steps`;
      }


    },

    mounted() {
      // this.initDynWidth('ultra-container', 5, 8, 4);
    },
  }
</script>

<style>
.work-package-circular-step-list {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  /* for cleanest look take multiple of 4 for grid-gap  */
  grid-gap: 8px;
  width: 100%;
  padding: 5px 0;
}
.work-package-circular-step-container {
  aspect-ratio: 1 / 1;
  display: flex;
  flex-shrink: 0;
}
</style>
